// Libs
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

// Components
import ConfirmCard from '../../../components/Cards/ConfirmCard';

// Actions
import { DeleteSharedKit } from '../../../actions/sharedKits';
import { OpenModal } from '../../../actions/modal';

// Hooks
import useUI from '../../../hooks/useUI';

// Utils
import { canOrderSharedKit } from '../utils/sharedKits';

// Constants
import {
  SHARED_KITS_PATH,
  deleteSharedKitMessage,
} from '../../../constants/sharedKits';

// Constants
import {
  CONFIRM_MODAL_HEIGHT_DESKTOP,
  CONFIRM_MODAL_HEIGHT_MOBILE,
  CONFIRM_MODAL_WIDTH_DESKTOP,
  CONFIRM_MODAL_WIDTH_MOBILE,
  CONFIRM_MODAL_WIDTH_TABLET,
} from '../../../constants/modals';

const useSharedKitActions = (kit) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isTabletMode, isMobileMode } = useUI();

  const onViewDetailsClick = useCallback(
    (kitId) => navigate(`${SHARED_KITS_PATH}/${kitId}`),
    [navigate],
  );

  const onDeleteClick = useCallback(
    (kitId) => {
      let width;
      if (isMobileMode) {
        width = CONFIRM_MODAL_WIDTH_MOBILE;
      } else if (isTabletMode) {
        width = CONFIRM_MODAL_WIDTH_TABLET;
      } else {
        width = CONFIRM_MODAL_WIDTH_DESKTOP;
      }

      dispatch(
        OpenModal({
          Component: ConfirmCard,
          props: {
            message: deleteSharedKitMessage,
            onConfirm: () =>
              dispatch(
                DeleteSharedKit({
                  kitId,
                  callback:
                    pathname === SHARED_KITS_PATH
                      ? null
                      : () => navigate(SHARED_KITS_PATH),
                }),
              ),
            isAcceptBtnMain: false,
            paddingContent: {
              xl: '40px 40px 30px',
              lg: '40px 40px 30px',
              md: '30px 16px 20px',
            },
          },
          styles: {
            width,
            minHeight: isMobileMode
              ? CONFIRM_MODAL_HEIGHT_MOBILE
              : CONFIRM_MODAL_HEIGHT_DESKTOP,
          },
        }),
      );
    },
    [dispatch, navigate, pathname, isMobileMode, isTabletMode],
  );

  const canOrder = useMemo(() => canOrderSharedKit(kit), [kit]);

  return {
    onViewDetailsClick,
    onDeleteClick,
    canOrder,
  };
};

export default useSharedKitActions;
